var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button } from "semantic-ui-react";
var UpdateCurrentBatchModal = /** @class */ (function (_super) {
    __extends(UpdateCurrentBatchModal, _super);
    function UpdateCurrentBatchModal(props) {
        var _this = _super.call(this, props) || this;
        _this.updateCurrentBatch = function () {
            _this.props.postRequest("/admin/rna/update-current-batch", {});
        };
        return _this;
    }
    UpdateCurrentBatchModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: this.updateCurrentBatch, label: 'Update Current Catalog Batch', labelPosition: 'left' }));
    };
    return UpdateCurrentBatchModal;
}(React.PureComponent));
export default UpdateCurrentBatchModal;
//# sourceMappingURL=UpdateCurrentBatchModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/UpdateCurrentBatchModal.js
// module id = 1466
// module chunks = 0